import React from "react";
import { FormattedMessage } from "react-intl";
import { Col, FormGroup, FormLabel } from "react-bootstrap";
import { Controller, UseFormReturn } from "react-hook-form";
import { EXTRA_APPLY_TO_MESSAGE, messages } from "../../EditExtra/messages";
import { SelectGroup } from "../SelectGroup";
import { FormType } from "../../EditExtra/types";

type RateApplyToInputProps = UseFormReturn<FormType> & { disabled: boolean; };

export function RateApplyToInput({ control, disabled }: RateApplyToInputProps) {
  return <FormGroup as={Col}>
    <FormLabel column sm={12}>
      <FormattedMessage {...messages.applyTo} />
    </FormLabel>
    <Col sm={3}>
      <Controller
        name="applyTo"
        control={control}
        render={({ field }) => (
          <SelectGroup optionDisplay={EXTRA_APPLY_TO_MESSAGE} disabled={disabled} {...field} />
        )}
      />
    </Col>
  </FormGroup>;
}